import { inviteUser as internalInviteUser } from "frontend/api";
import { Permission } from "shared/datamodel/schemas/user";

export async function inviteUser({
  usersPermissions,
  isPerSeatLicenseEnabled,
  documentId,
}: {
  usersPermissions: Record<string, Permission>;
  isPerSeatLicenseEnabled: boolean;
  documentId?: string;
}) {
  const response = await internalInviteUser({ usersPermissions, documentId, isPerSeatLicenseEnabled });
  return response;
}
